/* unplugin-vue-components disabled */import script from "./News.vue?vue&type=script&setup=true&lang=ts"
export * from "./News.vue?vue&type=script&setup=true&lang=ts"

import "./News.vue?vue&type=style&index=0&id=ef394a62&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef394a62"]])

export default __exports__